import React from 'react';
import { AppConfig } from '../config';

const API_HOST_URL = `https://${AppConfig.ApiBaseURL}`;

/**
 * 
 * @param {string} path 
 * @param {string} method 
 * @param {object} body 
 * @param {object} headers 
 * @param {object} queryParams 
 * @param {array} dependencies 
 * @param {object} options 
 * @returns 
 */
const useFetch = (
    path,
    method,
    body,
    headers,
    queryParams,
    dependencies = [],
    options = {},
) => {
    const [data, setData] = React.useState(null);
    const [error, setError] = React.useState(null);
    const didMount = React.useRef(false);

    React.useEffect(() => {
        if (options?.callOnMount === false && didMount?.current === false) return;
        call();
    }, dependencies);

    React.useEffect(() => {
        didMount.current = true;
    }, []);

    const call = async () => {
       let fetchUrl = '';
       let fetchOptions = {};
        if (path) {
            if (queryParams && Object.keys(queryParams).length) {
                fetchUrl = path + "?" + new URLSearchParams({ ...queryParams });
            } else {
                fetchUrl = path;
            }
        }
        if (method) {
            fetchOptions = ({ ...fetchOptions, method: method });
        }
        if (body) {
            fetchOptions = ({ ...fetchOptions, body: JSON.stringify({...body}) });
        }
        if (headers) {
            fetchOptions = ({ ...fetchOptions, headers: {
               "Accept": "*/*",
               "Accept-Encoding": "gzip, deflate, br",
               "Accept-Language": "en-US,en;q=0.9",
               "Connection": "keep-alive",
               "Cookie": document.cookie,
               ...headers,
               "AuthToken": `${process.env.REACT_APP_API_AUTH_TOKEN}`,
            }});
        }
        fetch(`${API_HOST_URL}${fetchUrl}`, fetchOptions)
        .then(res => res.json())
        .then((response) => {
            setData(response);
        })
        .catch((err) => {
            setError(err);
        });
    };

    return {
        data,
        error,
        call
    };
};

export default useFetch;
